// extracted by mini-css-extract-plugin
export default {"left-upload":"index_left-upload__MJaGW","right-upload":"index_right-upload__ObH6a"};